import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import Icon from '../components/Icon';
import IconMap from '../constants/IconMap';
import { CommonStyles, CommonProperties, Color } from '../styles';
import RowView from '../components/RowView';
import BaseText from '../components/BaseText';

const IconScreen = () => {
  return (
    <ScrollView style={CommonStyles.p5}>
      <BaseText style={styles.title}>Icon List:</BaseText>
      {Object.keys(IconMap).map((i) => (
        <RowView key={i} style={CommonStyles.my3}>
          <BaseText style={styles.text}>{i}</BaseText>
          <Icon style={CommonStyles.h2} name={i} color={Color.primary} />
        </RowView>
      ))}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  title: {
    ...CommonProperties.h2,
    ...CommonProperties.mb5,
  },
  text: {
    width: 160,
    ...CommonProperties.h4,
  },
});
export default IconScreen;
